import type { IPushTopicStore, PushTopicState } from 'src/use-cases/push/ports/IPushTopicStore'

const KEY = 'push:seller-news-topics'
const empty = (): PushTopicState => ({ token: '', topics: [], pending: [] })

export class PushTopicStore implements IPushTopicStore {
  #memory = empty()

  read(): PushTopicState {
    try {
      const raw = localStorage.getItem(KEY)
      if (raw) {
        const data = JSON.parse(raw)
        const list = (value: unknown): string[] => Array.isArray(value)
          ? value.filter((v): v is string => typeof v === 'string' && /^seller-news-[\w.~%-]+$/.test(v))
          : []
        if (typeof data.token === 'string') this.#memory = { token: data.token, topics: list(data.topics), pending: list(data.pending) }
      }
    } catch { /* Unavailable storage: this session still manages subscriptions. */ }
    return { ...this.#memory, topics: [...this.#memory.topics], pending: [...this.#memory.pending] }
  }

  write(state: PushTopicState) {
    this.#memory = { ...state, topics: [...state.topics], pending: [...state.pending] }
    try {
      localStorage.setItem(KEY, JSON.stringify(this.#memory))
    } catch { /* Keep memory fallback. */ }
  }
}
